namespace GeniuzPOS.ReportMasterData {
    export interface Report_1102Form {
        PluDesc: Serenity.StringEditor;
        SkuCode: Serenity.StringEditor;
        SellUnit: Serenity.StringEditor;
        SupplierId: Serenity.LookupEditor;
        SupplName: Serenity.StringEditor;
        CatCode: Serenity.LookupEditor;
        CatName: Serenity.StringEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat1Name: Serenity.StringEditor;
        SubCat2Code: Serenity.LookupEditor;
        SubCat2Name: Serenity.StringEditor;
        BrandCode: Serenity.LookupEditor;
        BrandName: Serenity.StringEditor;
        StyleId: Serenity.StringEditor;
        StyleName: Serenity.StringEditor;
        ColorId: Serenity.StringEditor;
        ColorName: Serenity.StringEditor;
        SizeId: Serenity.StringEditor;
        SizeName: Serenity.StringEditor;
        SellUnitPrice1: Serenity.DecimalEditor;
        SellUnitPrice2: Serenity.DecimalEditor;
        SellUnitPrice3: Serenity.DecimalEditor;
        SellUnitPrice4: Serenity.DecimalEditor;
        SellUnitPrice5: Serenity.DecimalEditor;
        SellUnitPrice6: Serenity.DecimalEditor;
        VatType: Serenity.StringEditor;
        VatCode: Serenity.StringEditor;
    }

    export class Report_1102Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1102';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report_1102Form.init)  {
                Report_1102Form.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(Report_1102Form, [
                    'PluDesc', w0,
                    'SkuCode', w0,
                    'SellUnit', w0,
                    'SupplierId', w1,
                    'SupplName', w0,
                    'CatCode', w1,
                    'CatName', w0,
                    'SubCat1Code', w1,
                    'SubCat1Name', w0,
                    'SubCat2Code', w1,
                    'SubCat2Name', w0,
                    'BrandCode', w1,
                    'BrandName', w0,
                    'StyleId', w0,
                    'StyleName', w0,
                    'ColorId', w0,
                    'ColorName', w0,
                    'SizeId', w0,
                    'SizeName', w0,
                    'SellUnitPrice1', w2,
                    'SellUnitPrice2', w2,
                    'SellUnitPrice3', w2,
                    'SellUnitPrice4', w2,
                    'SellUnitPrice5', w2,
                    'SellUnitPrice6', w2,
                    'VatType', w0,
                    'VatCode', w0
                ]);
            }
        }
    }
}
